import { Link } from "react-router-dom";

export default function Breadcrumb({ items }) {
  return (
    <nav className="mb-6 text-sm font-semibold text-slate-500" aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-2">
        <li><Link to="/" className="hover:text-primary">Home</Link></li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-2">
            <span>/</span>
            {item.to ? <Link to={item.to} className="hover:text-primary">{item.label}</Link> : <span className="text-dark">{item.label}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
